import React from 'react';
import { Logo } from '../../../../layout/BotBuilderSidebar/Logo/Logo';
import { LeaderBadge } from '../../../../modules/LoginRouter/components/LoginLayout/components/Badges/LeaderBadge';
import metaLogoSrc from 'assets/meta-partner.png';
import styles from './OnboardingLogosPanel.module.css';
import classNames from 'classnames';
import neilPatel from 'assets/neil-patel-transparent.svg';
import martechLogo from 'assets/best-web-platform.svg';
import entrepreneurLogo from 'assets/enterprneur-logo-black.svg';

export const OnboardingLogosPanel = ({ className }: { className?: string }) => {
  return (
    <div className={classNames(className, styles.column)}>
      <div className={styles.logos}>
        <Logo className={styles.mainLogo} />
        <div className={classNames(styles.partnersLogo, styles.row)}>
          <LeaderBadge className={styles.leader} whiteStyle />
          <img src={metaLogoSrc} className={styles.meta} />
        </div>
      </div>
      <div className={styles.neilBlock}>
        <div className={styles.neilPicture}>
          <img src={neilPatel} className={styles.neil} />
        </div>
        <div className={styles.heading}>Neil Patel</div>
        <div className={styles.text}>Forbes Top 10 Marketer</div>
        <div className={classNames(styles.text, styles.quote)}>
          Sales outreach automation results in radically improved website
          conversion rate and cost per lead. Think about what a 20% lead capture
          rate from digital ads, SEO and content marketing would do for your
          business growth. Customers.ai X-Ray Lead Generation Pixel with
          automated sales outreach is a quantum leap in marketing technology.
        </div>

        <div className={classNames(styles.row, styles.footerLogos)}>
          <img src={martechLogo} className={styles.martechLogo} />
          <img src={entrepreneurLogo} className={styles.entrepreneurLogo} />
        </div>
      </div>
    </div>
  );
};
